import React from "react";

const TrendingUp = () => (
  <svg id="Trending_Up" data-name="Trending Up" xmlns="http://www.w3.org/2000/svg" width="11.667" height="7" viewBox="0 0 11.667 7">
    <path
      id="Path_12999"
      data-name="Path 12999"
      d="M20.5,12.4l1.336,1.336-2.847,2.847-2.333-2.334-4.323,4.329.823.822,3.5-3.5,2.333,2.333,3.675-3.669L24,15.9V12.4Z"
      transform="translate(-12.333 -12.4)"
      fill="#969696"
    />
  </svg>
);

export default TrendingUp;
